import { newQuestionTypes } from 'lib/enums/questionTypes';

const GetQuestionType = (state) => {
  switch (state) {
    case newQuestionTypes.openQuestion.toUpperCase():
      return 'Open question';
    case newQuestionTypes.address.toUpperCase():
      return 'Address';
    case newQuestionTypes.date.toUpperCase():
      return 'Date';
    case newQuestionTypes.phone.toUpperCase():
      return 'Phone';
    case newQuestionTypes.text.toUpperCase():
      return 'Text';
    case newQuestionTypes.numeric.toUpperCase():
      return 'Numeric';
    case newQuestionTypes.scale.toUpperCase():
      return 'Scale';
    case newQuestionTypes.rating.toUpperCase():
      return 'Rating';
    case newQuestionTypes.nps.toUpperCase():
      return 'NPS';
    case newQuestionTypes.multipleChoice.toUpperCase():
      return 'Multiple choice';
    case newQuestionTypes.singleChoice.toUpperCase():
      return 'Single choice';
    case newQuestionTypes.yesNo.toUpperCase():
      return 'Yes/No';
    case newQuestionTypes.fileUpload.toUpperCase():
      return 'File upload';
    case newQuestionTypes.pictureChoice.toUpperCase():
      return 'Picture choice';
    case newQuestionTypes.quiz.toUpperCase():
      return 'Quiz';
    case newQuestionTypes.choice.toUpperCase():
      return 'Choice';
    case newQuestionTypes.likert.toUpperCase():
      return 'Likert question';
    case newQuestionTypes.media.toUpperCase():
      return 'Media';
    default:
      return 'Unknown';
  }
};

export default GetQuestionType;
